import Vue from 'vue';
import moment from 'moment';
import table from '../../components/ins-manage/ins-table.vue';
import applyConfirmDialg from './dlg-apply-confirm.vue';
import { formPartnerOptions } from './ins-utils.ts';
export default Vue.extend({
    components: {
        'el-balance-list': table,
        'el-confirm-dlg': applyConfirmDialg,
    },
    data: function () {
        return {
            dialogApplyVisiable: false,
            applyConfirmInfo: {
                channelName: '',
                endTime: '',
                sumBillNumber: 0,
                sumAmount: 0,
                sumOrderAmount: 0,
            },
            requestConfig: {
                url: '/proxy/carInsurance/channelBill/queryFeeList',
                method: 'post',
            },
            searchConfig: [
                {
                    label: '对账渠道',
                    type: 'select',
                    key: 'partnerIds',
                    multiple: true,
                    labelWidth: '80px',
                    option: [],
                },
                {
                    label: '签单截止日期',
                    key: 'endTime',
                    type: 'date',
                    clearable: false,
                    placeholder: '请选择日期',
                    message: '查询该时间以前所有未结费用',
                    pickerOptions: {
                        disabledDate: function (time) {
                            return time.getTime() > Date.now();
                        },
                    },
                },
            ],
            defaultSearch: {
                endTime: moment().format('YYYY-MM-DD'),
            },
            mutexDisableParam: {
                closeMutex: true,
            },
            tableConfig: [
                {
                    label: '流水号',
                    prop: 'billNo',
                    tooltip: true,
                    width: '220px',
                },
                {
                    label: '签单日期',
                    prop: 'orderTime',
                    tooltip: true,
                    width: '128px',
                    formatter: function (val) {
                        return moment(val).format('YYYY-MM-DD');
                    },
                },
                {
                    label: '保单号',
                    prop: 'policyNo',
                    tooltip: true,
                    width: '140px',
                },
                {
                    label: '批单号',
                    prop: 'endorseNo',
                    tooltip: true,
                    width: '130px',
                },
                {
                    label: '保单类型',
                    prop: 'orderTypeName',
                    width: '110px',
                },
                {
                    label: '险种类别',
                    prop: 'policyTypeName',
                    width: '150px',
                },
                {
                    label: '对账渠道',
                    prop: 'channelName',
                    width: '185px',
                },
                {
                    label: '保险公司',
                    prop: 'insCompanyName',
                    width: '185px',
                },
                {
                    label: '投保城市',
                    prop: 'insuranceCityName',
                    tooltip: true,
                    width: '130px',
                },
                {
                    label: '保费',
                    prop: 'orderAmount',
                    width: '110px',
                    formatter: function (val) {
                        return val;
                    },
                },
                {
                    label: '税点',
                    prop: 'taxPoint',
                    tooltip: true,
                    width: '80px',
                },
                {
                    label: '剔税保费',
                    prop: 'afterTaxPremiumFee',
                    tooltip: true,
                    width: '110px',
                    formatter: function (val) {
                        return val;
                    },
                },
                {
                    label: '推广费比例',
                    prop: 'rate',
                    width: '102px',
                },
                {
                    label: '按比例推广费',
                    prop: 'rateAmount',
                    width: '116px',
                    formatter: function (val) {
                        return val;
                    },
                },
                {
                    label: '定额推广费',
                    prop: 'quotaAmount',
                    width: '102px',
                },
                {
                    label: '推广费总额',
                    prop: 'amount',
                    width: '102px',
                    formatter: function (val) {
                        return val;
                    },
                },
            ],
        };
    },
    created: function () {
        var _this = this;
        formPartnerOptions().then(function (res) {
            _this.searchConfig[0].option = res;
        });
    },
    methods: {
        showConfirmDlg: function () {
            this.dialogApplyVisiable = true;
        },
        shut: function () {
            this.dialogApplyVisiable = false;
        },
        showLoading: function () {
            window.loading = Vue.prototype.$loading({
                spinner: 'el-icon-loading',
                background: 'rgba(300, 300, 300, 0.5)',
                customClass: 'loading',
                body: true,
            });
        },
        hideLoading: function () {
            window.loading && window.loading.close();
        },
        applyCheckbook: function () {
            var _this = this;
            this.showLoading();
            this.queryBillInfo().then(function (res) {
                _this.hideLoading();
                if (res) {
                    _this.showApplyConfirmDlg(res);
                }
            });
        },
        showApplyConfirmDlg: function (res) {
            var channelName = res.channelName, sumBillNumber = res.sumBillNumber, sumAmount = res.sumAmount, sumOrderAmount = res.sumOrderAmount;
            this.applyConfirmInfo = {
                endTime: this.getEndTime(),
                partnerIds: this.getParternIds(),
                channelName: channelName,
                sumBillNumber: sumBillNumber,
                sumAmount: sumAmount,
                sumOrderAmount: sumOrderAmount,
            };
            this.showConfirmDlg();
        },
        getEndTime: function () {
            return this.$refs.balanceTable.getParams().endTime;
        },
        getParternIds: function () {
            var partnerIds = this.$refs.balanceTable.getParams().partnerIds;
            if (Array.isArray(partnerIds) && partnerIds.length === 0) {
                partnerIds.push(this.searchConfig[0].option[0].val);
            }
            return partnerIds;
        },
        queryBillInfo: function () {
            var params = {
                endTime: this.getEndTime(),
                partnerIds: this.getParternIds(),
            };
            return this.$request({
                url: '/proxy/carInsurance/channelBill/updateFeeList',
                method: 'post',
                data: params,
                timeout: 3 * 60 * 1000,
            }).then(function (res) {
                if (!res || res.errorCode) {
                    return;
                }
                return res;
            });
        },
    },
});
